import { render, staticRenderFns } from "./VMCheckbox.vue?vue&type=template&id=3c95a014&scoped=true&lang=pug&"
import script from "./VMCheckbox.vue?vue&type=script&lang=js&"
export * from "./VMCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VMCheckbox.vue?vue&type=style&index=0&id=3c95a014&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c95a014",
  null
  
)

export default component.exports